import { format as formatRut } from 'rut.js';

import { StudentGradesMapResponse } from '../../../api/requests/gradeEntry';
import { StudentProps } from '../parts/AddEvaluationGrade/AddEvaluationGradeEntry';

function getStudentIdentification({
  run,
  passportNumber,
}: Pick<StudentGradesMapResponse, 'run' | 'passportNumber'>) {
  if (run?.trim()) {
    return formatRut(run);
  }

  return passportNumber?.trim() ?? '';
}

export default function mapStudentsProps(data: StudentGradesMapResponse[]) {
  return data.map<StudentProps>(
    ({
      fullName,
      run,
      passportNumber,
      id: studentId,
      testGrades,
      examGrade,
      onlineGrade,
      partialGrade,
      finalGrade,
      finalForcedGrade,
      partialGradeGroup,
    }) => {
      let _testGrades = [];
      for (const key in testGrades) {
        _testGrades.push(testGrades[key]);
      }
      return {
        fullname: fullName,
        id: String(studentId),
        identification: getStudentIdentification({ run, passportNumber }),
        testGradeGroup:
          partialGradeGroup
            .filter((gradeGroup) => gradeGroup.type === 'subevaluations')
            .map((pGradeGroup) => ({
              id: pGradeGroup?.group?.id,
              grade: pGradeGroup.grade,
              percentage: pGradeGroup.percentage,
            })) ?? [],
        testGrade: `${partialGrade ?? ''}`,
        finalGrade: `${finalGrade ?? ''}`,
        finalForcedGrade: `${finalForcedGrade ?? ''}`,
        noteExamen: `${examGrade.grade ?? ''}`,
        onlineGrade: `${onlineGrade?.grade ?? ''}`,
        notes: _testGrades.map(
          ({ studentTestGradeId, testGradeId, grade }) => ({
            studentTestGradesId: studentTestGradeId || null,
            studentTestGradesGrade: `${grade ?? ''}`,
            testGradeId,
            studentId,
          }),
        ),
        finalGrades: {
          finalGradeFinalTest: examGrade.studentFinalGradeId,
          finalGradeId: examGrade.finalGradeId,
          studentFinalGradesGrade: `${
            examGrade?.grade ? examGrade?.grade : ''
          }`,
          studentFinalGradesId: examGrade.studentFinalGradeId,
        },
        studentId,
      };
    },
  );
}
